import React, { useState } from 'react';
import { BorderT1 } from '../../Atoms';
import { Row, Col } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import { faSpellCheck, faClock, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Bold, Paragraph, YellowCircleIcon, EventInfo } from '../../Atoms';
import { getFormattedDateMultilanguage } from '../../../Domain/Utils/DateUtilities/DateUtilities';
import { SchedulerCalendar } from '../../Modals/SchedulerCalendar/SchedulerCalendar';
import './TelepresencePurchaseCard.css';
import RegisterUser from '../../Atoms/RegisterUser/RegisterUser';
import { getIconZone } from '../../../Domain/Utils/SelectionUtilies/SelectionUtilies';
import { IconoMundo } from '../../../Resources/Images/ImagesLogo';

export const TelepresencePurchaseCard = ({
  parameters,
  disabled = false,
  schedulerInfo = {},
  allWidth = false,
  badgeImage,
  changeView,
  showEnrrolmentForm,
  setShowEnrrolmentForm,
  handleUpdateMemberships,
  membershipListIdScheduler,
  isMobile,
  language,
  props
}) => {
  const combo = schedulerInfo?.scheduler_membership_price?.filter(
    (current) => current?.description?.length > 0
  );

  const [showCalendar, setShowCalendar] = useState(false);

  const certifiableHours = () => {
    const totalHorasCertificables =
      schedulerInfo?.practice_hours + schedulerInfo.course_duration?.hours;
    return totalHorasCertificables
      ? `${totalHorasCertificables} ${parameters?.TEXT_CERTIFIABLE_HOURS?.value}`
      : null;
  };

  return (
    <>
      <div
        className={`${
          membershipListIdScheduler === schedulerInfo.id ? 'telepresential-purchase' : ''
        } position-relative text-center py-2 mx-lg-0 mx-4 membership-card-container ${
          changeView
            ? 'card-expanse gap-1'
            : 'telepresence-purchase-card__container membership-card-container'
        }`}>
        <Bold className="lt-card-title text-center" color="var(--corporative-yellow)">
          {parameters?.PD_WEB_LABEL?.value}
        </Bold>
        <Row className="gap-0">
          <Col
            className={`d-flex justify-content-center align-items-center ${
              changeView ? '' : 'pt-3'
            }`}
            lg={{ order: 1, span: changeView ? 4 : 12 }}>
            {badgeImage && (
              <img
                className="img-fluid ps-md-3 ps-2 py-3 py-lg-0"
                style={{
                  maxWidth: changeView ? (isMobile ? '50%' : '90%') : '55%',
                  height: 'auto'
                }}
                alt="certificate student"
                src={badgeImage}
              />
            )}
          </Col>
          <Col
            className={`${changeView ? 'mt-2' : 'mt-3'}`}
            lg={{ order: changeView ? 3 : 2, span: 12 }}>
            <div className={`d-flex flex-wrap justify-content-around ${changeView ? 'pt-3' : ''}`}>
              <IconCardPurchase
                changeView={changeView}
                title={parameters?.TIM_ZON_LABEL?.value}
                iconSvg={IconoMundo}
                value={
                  schedulerInfo?.time_zone !== undefined
                    ? schedulerInfo?.time_zone.length > 1
                      ? schedulerInfo?.time_zone?.[schedulerInfo?.time_zone_id - 1]
                      : schedulerInfo?.time_zone
                    : parameters?.PRT_SCH_TM?.value
                }
              />
              <IconCardPurchase
                changeView={changeView}
                title={parameters?.CRS_DUR_LABEL?.value}
                icon={faClock}
                value={
                  schedulerInfo?.course_duration
                    ? schedulerInfo.course_duration?.hours
                        ?.toString()
                        ?.concat(' ' + parameters?.HOURS?.value)
                    : parameters?.PRT_SCH_TM?.value
                }
              />
              <IconCardPurchase
                changeView={changeView}
                title={parameters?.CRS_CHA_LABEL?.value}
                icon={faSpellCheck}
                value={
                  schedulerInfo?.practice_hours
                    ?.toString()
                    ?.concat(' ' + parameters?.HOURS?.value) || parameters?.PRT_SCH_TM?.value
                }
              />
            </div>
          </Col>
          <Col lg={{ order: changeView ? 2 : 3, span: changeView ? 7 : 12 }}>
            <div className={`${changeView ? 'pt-2' : ''}`}>
              <div
                className={`d-flex flex-wrap align-items-center gap-3 pt-3 text-black ${
                  allWidth ? '' : 'justify-content-center'
                }`}>
                <div className={`d-flex ${allWidth ? 'flex-row' : 'flex-column'} gap-4 w-100 px-4`}>
                  <EventInfo
                    first={parameters?.START_COURSE_LABEL?.value}
                    second={
                      disabled
                        ? parameters?.NEXT_OPEN_LABEL?.value
                        : getFormattedDateMultilanguage(schedulerInfo.start_date, false, language)
                    }
                    secondSize="16px"
                  />
                  <EventInfo
                    first={parameters?.END_COURSE_LABEL?.value}
                    second={
                      disabled
                        ? parameters?.NEXT_OPEN_LABEL?.value
                        : getFormattedDateMultilanguage(schedulerInfo.end_date, false, language)
                    }
                    secondSize="16px"
                  />
                </div>
              </div>

              <div className="text-center mt-3 pt-2 px-1 ">
                <button
                  disabled={disabled || !schedulerInfo?.id}
                  data-tip
                  // data-for={`calendar`}
                  className="btn-scheduler px-3 text-black"
                  onClick={() => {
                    setShowCalendar(true);
                  }}>
                  {parameters?.LMS_INFO_SCHEDULER?.value}
                  <FontAwesomeIcon className="" icon={faCalendarDays} fontSize={'20px'} />
                </button>

                <ReactTooltip id={`calendar`} effect="solid">
                  <span style={{ fontWeight: 'normal' }}>{parameters?.CALENDAR_LABEL?.value}</span>
                </ReactTooltip>
              </div>
            </div>
          </Col>
        </Row>

        <div className="certifiableHours pt-lg-2 mb-4 pb-2">
          <BorderT1 className="p-2 rounded border-0">
            <Bold size="21px">{certifiableHours()}</Bold>
          </BorderT1>
        </div>

        <div
          style={{ position: 'absolute', marginTop: '-20px', left: '0px', zIndex: 4 }}
          className="d-flex gap-3 justify-content-center w-100">
          {schedulerInfo?.id > 0 ? (
            <RegisterUser
              disabled={disabled}
              parameters={props?.parameters}
              schedulerIdCourse={schedulerInfo?.id}
              showEnrrolmentForm={showEnrrolmentForm}
              setShowEnrrolmentForm={setShowEnrrolmentForm}
            />
          ) : (
            <button
              // type="button"
              aria-label="Submit button"
              onClick={() => props?.scrollToCourseMembership()}
              style={{
                borderRadius: '5px',
                background: 'rgba(168, 162, 6, 0.967)',
                opacity: '1',
                color: 'black'
              }}
              className={'btn m-0 '}>
              {parameters?.SUCCES_CREDIT?.value}
            </button>
          )}

          <button
            type="button"
            aria-label="Submit button"
            onClick={() => {
              handleUpdateMemberships(schedulerInfo?.id);
              props?.scrollToCourseMembership();
            }}
            style={{
              height: '44px',
              borderRadius: '6px',
              background:
                schedulerInfo?.id > 0 ? 'var(--corporative-yellow)' : 'rgba(168, 162, 6, 0.967)',
              opacity: '1',
              color: 'black',
              border: 'none'
            }}
            className={`btn m-0 ${schedulerInfo?.id > 0 ? 'mt-1' : 'mt-0'}`}>
            {parameters?.STUDY_PLAN?.value}
          </button>
        </div>
      </div>

      {/* {showCalendar && ( */}
      <SchedulerCalendar
        isShow={showCalendar}
        handleShow={setShowCalendar}
        zone={schedulerInfo?.time_zone}
        iconZone={getIconZone(parseInt(schedulerInfo?.zone))}
        parameters={parameters}
        language={language}
        schedulerInfo={schedulerInfo}
        // {...{ calendarList }}
      />
      {/* )} */}
      {/* <SchedulerCombo isShow={showCombo} handleShow={setShowCombo} {...{ parameters, combo }} /> */}
    </>
  );
};

const IconCardPurchase = ({ changeView, title, value, icon = null, iconSvg = null }) => {
  return (
    <div
      className={`d-flex align-items-center ${
        changeView ? 'flex-lg-row flex-column gap-2' : 'flex-column'
      }`}>
      <YellowCircleIcon
        colorIcon="black"
        iconsSvg={iconSvg}
        icon={icon}
        size="40px"
        widthIcon={'40px'}
        bdRadius={'50%'}
      />
      <div
        className={`d-flex flex-column  ${
          changeView ? 'text-lg-start text-center' : 'align-items-center'
        }`}>
        <Paragraph size="16px">{title}</Paragraph>
        <Bold size="18px">{value}</Bold>
      </div>
    </div>
  );
};
